<script>
  export let marginTop;
  const buildStyle = () => {
    return `margin:0; margin-top:${marginTop}px; @media screen and (max-width: 768px) {margin-top:${Math.round(
      marginTop / 2.0
    )}}`;
  };
</script>

<div class="vertical-spacing" style={buildStyle()} />
